import {withStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {StateService} from "../services/StateService";
import {observer} from "mobx-react-lite";
import "./WinnerTable.scss";
import {Winner} from "../types";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: '#212328 !important',
    },
    "&:nth-of-type(even)": {
      backgroundColor: '#1C1E22 !important'
    }
  },
}))(TableRow);

interface WinnerTableProps {
  state: StateService;
}

export const WinnerTable = observer((props: WinnerTableProps) => {

  let me = props.state.authentication.getAddress();
  let winners: Winner[] = props.state.winners.getWinners();

  if (winners.length === 0) {
    return (<></>);
  }

  return (
    <TableContainer className="tableContainer" component={Paper}>
      <p style={{display: "none"}}>{props.state.winners.size()}</p>
      <Table className="tableBox" aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell className="cellAddress">
              Address
            </StyledTableCell>
            <StyledTableCell align="right">
              Stake
            </StyledTableCell>
            <StyledTableCell align="right">
              Slots
            </StyledTableCell>
            <StyledTableCell align="right">
              Reward
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {winners.map((row, index) => (
            <StyledTableRow
                key={index}
                className={row.address.toLowerCase() === me ? "rowActive" : ""}
            >
              <StyledTableCell
                  className="cellOne"
                  component="td"
                  scope="row"
              >
                {row.address.toLowerCase() === me && <span className="me">Me</span>}
                {row.address}
              </StyledTableCell>

              <StyledTableCell align="right">{row.stake.toFixed(2)} FET</StyledTableCell>
              <StyledTableCell align="right">{row.slots}</StyledTableCell>
              {row.reward
                  ? <StyledTableCell align="right">{row.reward} ETH</StyledTableCell>
                  : <StyledTableCell align="right">
                      <RemoveCircleIcon
                        style={{ color: "#E8B853", fontSize: 29 }}
                      />
                  </StyledTableCell>
              }
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>)
});
